import { dataBarChartAltSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconBarChartAltSolid = /*#__PURE__*/createIcon(dataBarChartAltSolid)
export default IconBarChartAltSolid
